import React, { useState } from "react";
import "./changePassword.css";
import { UpdatePassword } from "../../services/btc-api.service";
import { useSelector } from "react-redux";
export default function ChangePassword() {
  const user = useSelector((state) => state.user.user);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  const handleCurrentPasswordChange = (e) => {
    setCurrentPassword(e.target.value);
  };

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (newPassword !== confirmPassword)
      newErrors.confirmPassword = "Entered password don't match";

    if (!confirmPassword)
      newErrors.confirmPassword = "Enter confirm password";

    if (!newPassword)
      newErrors.changePassword = "Enter password you want to change";

    if (!currentPassword)
      newErrors.currentPassword = "Entered confirmation password ";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        await UpdatePassword({
          email: user.email,
          currentPassword: currentPassword,
          password: newPassword,
        });
      } catch (error) {
        console.log(error);
      }
    }
  };
  return (
    <div className="container">
      <form className="formStyle" onSubmit={handleSubmit}>
        <div className="row justify-content-center align-items-center mt-4">
          <div className="col-12 col-md-4 col-lg-6 ">
            <input
              type="password"
              placeholder="Current Password"
              className="border border-secondary rounded mb-2 form-control changepasswordcontainerHeight"
              value={currentPassword}
              onChange={handleCurrentPasswordChange}
            />
            {errors.currentPassword && (
              <p className="text-danger">{errors.currentPassword}</p>
            )}
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-md-5 col-lg-6">
            <input
              type="password"
              placeholder="Change Password"
              className={`border ${errors.confirmPassword ? "border-danger" : "border-secondary"
                } rounded mb-2 form-control changepasswordcontainerHeight`}
              value={newPassword}
              onChange={handleNewPasswordChange}
            />
            {errors.changePassword && (
              <p className="text-danger">{errors.changePassword}</p>
            )}
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-md-5 col-lg-6">
            <input
              type="password"
              placeholder="Confirm Password"
              className={`border ${errors.confirmPassword ? "border-danger" : "border-secondary"
                } rounded mb-2 form-control changepasswordcontainerHeight `}
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
            />
            {errors.confirmPassword && (
              <p className="text-danger">{errors.confirmPassword}</p>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center ">
          <div className="row">
            <div className="col-12 col-md-5 col-lg-4  ">
              <button type="submit" className="buttonstyle-7">
                Update Now
              </button>
            </div>
          </div>
        </div>
      </form>
      <div style={{ marginBottom: 200 }}></div>
    </div>
  );
}
